import { Component, inject, effect, input, output } from '@angular/core';
import { NavigationStart, Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';
import * as fromMenu from '@teamfoster/sdk/menu-ngrx';
import { toSignal } from '@angular/core/rxjs-interop';
import { LinkComponent } from '@teamfoster/sdk/button';
import { FromMenuPipe } from '@teamfoster/sdk/menu-ngrx';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';
import { MenuTheme } from 'src/app/shared/models';
import { IconComponent } from '@teamfoster/sdk/icon';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
  imports: [RouterModule, LinkComponent, FromMenuPipe, FromDictionaryPipe, IconComponent],
})
export class TopbarComponent {
  private router = inject(Router);

  loading = input<boolean>(false);
  menuActive = input<boolean>(false);
  logoClass = input<string>('');
  menu = input<fromMenu.MenuItem[]>([]);
  theme = input<MenuTheme>('light');

  toggleOverlay = output<void>();
  closeOverlay = output<void>();
  openOverlay = output<void>();

  private navigationStart$ = toSignal(this.router.events.pipe(filter(e => e instanceof NavigationStart)));

  routerEffect$ = effect(() => {
    const navigationStart = this.navigationStart$();

    if (this.menuActive()) {
      //this.closeOverlay.emit();
    }
  });

  isHalfway(index: number): boolean {
    return index === Math.floor(this.menu().length / 2);
  }

  isExternalLink(page: fromMenu.MenuItem): boolean {
    return !page.routerLink?.length;
  }
}
